import { LitElement, html } from '@hh/global.js'

class ComponentToggle extends LitElement {
  static properties = {
    checked: {
      type: Boolean,
      reflect: true,
    },
  }

  connectedCallback() {
    super.connectedCallback()
    this.button = this.querySelector('button')
    this.checkbox = this.querySelector('input[type="checkbox"]')

    if (this.button) {
      this.boundHandleButton = this.handleButton.bind(this)
      this.button.addEventListener('click', this.boundHandleButton)
    }
  }

  disconnectedCallback() {
    if (this.button && this.boundHandleButton) {
      this.button.removeEventListener('click', this.boundHandleButton)
    }
    super.disconnectedCallback()
  }

  handleButton() {
    this.checked = !this.checked

    if (this.checkbox) {
      this.checkbox.checked = this.checked

      const inputEvent = new Event('input', {
        bubbles: true,
        cancelable: true,
        composed: true,
      })

      this.checkbox.dispatchEvent(inputEvent)
    }

    this.button?.setAttribute('aria-checked', this.checked.toString())
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('component-toggle', ComponentToggle)
